import React from "react";

export default function LeftPanel(props) {
  return <div className="signup-left-wrapper text-center">{props.children}</div>;
}
